import { getFullUrlPure } from 'hubspot-url-utils/pure';
import * as ClassicHublets from 'hubspot-url-utils/hublets';
import * as Hublets from 'hubspot-url-utils/hublets-next';
const curriedGetOrigin = subdomain => env => hublet => getFullUrlPure(subdomain, hublet, env);
export const getAllowedOrigins = () => {
  const getLocal = curriedGetOrigin('local');
  const getApp = curriedGetOrigin('app');
  const getLocalQA = getLocal('qa');
  const getAppQA = getApp('qa');
  const getLocalProd = getLocal('prod');
  const getAppProd = getApp('prod');
  const localQa = Object.values(ClassicHublets).map(getLocalQA);
  const qa = Object.values(ClassicHublets).map(getAppQA);
  const localProd = Object.values(Hublets).map(getLocalProd);
  const prod = Object.values(Hublets).map(getAppProd);
  const localTestEnv = 'https://local.hsappstatic.net';
  const staticTestEnv = 'https://static.hsappstatic.net';
  return [...localQa, ...qa, ...localProd, ...prod, localTestEnv, staticTestEnv];
};